const basicHeader = {
	header: [
		{ id: 0, grow: 2 },
		{ id: 1, grow: 1 },
	],
};

const basicInitialBodyRow = [
	{ id: 2, grow: 2 },
	{ id: 3, grow: 2 },
];

export const slackTemplates = [
	{
		id: 0,
		header: [{ id: 0, grow: 2 }],
		body: [[{ id: 1, grow: 2 }]],
	},
];

export default [
	{
		id: 0,
		...basicHeader,
		body: [[{ id: 2, grow: 2 }]],
	},
	{
		id: 1,
		...basicHeader,
		body: [[...basicInitialBodyRow]],
	},
	{
		id: 2,
		...basicHeader,
		body: [
			[...basicInitialBodyRow],
			[
				{ id: 4, grow: 2 },
				{ id: 5, grow: 2 },
			],
		],
	},
	{
		id: 3,
		...basicHeader,
		body: [[...basicInitialBodyRow], [{ id: 4, grow: 2 }]],
	},
	{
		id: 4,
		...basicHeader,
		body: [[{ id: 2, grow: 2 }], [{ id: 3, grow: 2 }]],
	},
	{
		id: 5,
		...basicHeader,
		body: [[{ id: 2, grow: 1, isMultiline: true }]],
	},
	{
		id: 6,
		header: [
			{ id: 0, grow: 1, isImage: true },
			{ id: 1, grow: 4 },
			{ id: 2, grow: 2 },
		],
		body: [[{ id: 3, grow: 2, isMultiline: true }]],
	},
	{
		id: 7,
		header: [
			{ id: 0, grow: 1, isImage: true },
			{ id: 1, grow: 4 },
		],
		body: null,
	},
	{
		id: 8,
		header: null,
		body: [
			[
				{ id: 0, grow: 1, isImage: true },
				{ id: 1, grow: 1, isMultiline: true },
			],
		],
	},
	{
		id: 9,
		header: [
			{ id: 0, grow: 1, isImage: true },
			{ id: 1, grow: 4 },
			{ id: 2, grow: 2 },
		],
		body: [[{ id: 3, grow: 2, isMultiline: true, forceShowMore: true }]],
	},
];
